<fin-corporate-widget [imageFromFragment]="'CORPORATE.fragments.nextTripsWidgetImage'">
  <fcom-tabs [bottomBorder]="false" (clickedTab)="tabChanged($event.index)" *ngIf="enableTabs$ | async">
    <fcom-tab
      [title]="'CORPORATE.corporatePortal.widgets.nextTrips.companyTripsTab' | finLocalization"
      [active]="(widgetTripType$ | async) === WidgetTripType.COMPANY_TRIPS"
      [disabled]="loading"
    ></fcom-tab>
    <fcom-tab
      [title]="'CORPORATE.corporatePortal.widgets.nextTrips.myTripsTab' | finLocalization"
      [active]="(widgetTripType$ | async) === WidgetTripType.MY_TRIPS"
      [disabled]="loading"
    ></fcom-tab>
  </fcom-tabs>
  <div *ngIf="trips$ | async as trips; else loader">
    <ng-container *ngIf="!loading; else loader">
      @for (trip of trips; track trip) {
        <ng-container *ngIf="(isMobile$ | async) === false">
          <ng-container *ngTemplateOutlet="desktop; context: { trip }"></ng-container>
        </ng-container>
        <ng-container *ngIf="(isMobile$ | async) === true">
          <ng-container *ngTemplateOutlet="mobile; context: { trip }"></ng-container>
        </ng-container>
      }

      <div
        *ngIf="trips.length === 0"
        class="border rounded-large grey-25-bg ps-xxlarge-y ps-large-x align-center"
        data-testid="no-results-container"
      >
        <span *ngIf="(widgetTripType$ | async) === WidgetTripType.COMPANY_TRIPS">
          {{ 'CORPORATE.corporatePortal.widgets.nextTrips.noFlights' | finLocalization }}
        </span>
        <span *ngIf="(widgetTripType$ | async) === WidgetTripType.MY_TRIPS">
          {{ 'CORPORATE.corporatePortal.widgets.nextTrips.noMyFlights' | finLocalization }}
        </span>
      </div>
    </ng-container>

    <div class="flex flex--end ms-large-t">
      <fcom-button
        *ngIf="trips.length > 0"
        [text]="'CORPORATE.corporatePortal.widgets.nextTrips.seeAll' | finLocalization"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [icon]="{
          name: SvgLibraryIcon.ARROW_RIGHT,
          position: IconPosition.RIGHT,
        }"
        [mode]="ButtonMode.FILL_MOBILE"
        (clickBtn)="navigateToTrips()"
      ></fcom-button>
      <fcom-button
        *ngIf="trips.length === 0"
        [text]="'CORPORATE.corporatePortal.widgets.nextTrips.bookFlight' | finLocalization"
        [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
        [icon]="{
          name: SvgLibraryIcon.ARROW_RIGHT,
          position: IconPosition.RIGHT,
        }"
        [mode]="ButtonMode.FILL_MOBILE"
        (clickBtn)="scrollToBookingWidget()"
      ></fcom-button>
    </div>
  </div>
</fin-corporate-widget>

<ng-template #loader>
  <div class="ms-xlarge-y">
    <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
  </div>
</ng-template>

<ng-template #desktop let-trip="trip">
  <div class="flex flex--space-between border-bottom ps-small-y font-body-2">
    <div class="column ps-small-r" data-hj-suppress>
      <div class="bold-type truncate overflow-hidden">
        {{ trip.departure.locationTitle }} - {{ trip.arrival.locationTitle }}
      </div>
      <div class="medium-type truncate overflow-hidden">
        <span>{{ trip.departure.dateTime | finDateFormat: 'FULL_NO_YEAR' }}</span>
        <fcom-icon class="ms-xxsmall-x icon-small" [name]="SvgLibraryIcon.DEPARTURE"></fcom-icon>
        <span>{{ trip.departure.dateTime | finTime }}</span>
      </div>
    </div>
    <div class="column ps-small-r">
      <div class="medium-type truncate overflow-hidden">
        {{ 'CORPORATE.corporatePortal.tripsView.table.passengers' | finLocalization }}
      </div>
      <div class="bold-type truncate overflow-hidden" data-hj-suppress>
        <span *ngIf="trip.passengers.length > 1">
          {{
            'CORPORATE.corporatePortal.tripsView.table.passengersField'
              | finLocalization: { amount: trip.passengers.length }
          }}
        </span>
        <span *ngIf="trip.passengers.length === 1">
          {{ trip.passengers[0].firstName + ' ' + trip.passengers[0].lastName | titlecase }}
        </span>
      </div>
    </div>
    <div class="column flex flex--end flex--middle">
      <fcom-button
        [text]="'CORPORATE.corporatePortal.tripsView.mobile.manageButton' | finLocalization"
        [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
        [icon]="{
          name: SvgLibraryIcon.ARROW_RIGHT,
          position: IconPosition.RIGHT,
        }"
        (clickBtn)="manageBooking(trip)"
      ></fcom-button>
    </div>
  </div>
</ng-template>

<ng-template #mobile let-trip="trip">
  <button class="block fill" (click)="manageBooking(trip)">
    <div class="flex align-left font-body-2 border-bottom ps-small-y">
      <div class="flex-1" data-hj-suppress>
        <div class="bold-type">{{ trip.departure.locationTitle }} - {{ trip.arrival.locationTitle }}</div>
        <div>
          <span>{{ trip.departure.dateTime | finDateFormat: 'FULL_NO_YEAR' }}</span>
          <fcom-icon class="ms-xxsmall-x icon-small" [name]="SvgLibraryIcon.DEPARTURE"></fcom-icon>
          <span>{{ trip.departure.dateTime | finTime }}</span>
        </div>
        <div class="">
          <span *ngIf="trip.passengers.length > 1">
            {{
              'CORPORATE.corporatePortal.tripsView.table.passengersField'
                | finLocalization: { amount: trip.passengers.length }
            }}
          </span>
          <span *ngIf="trip.passengers.length === 1">
            {{ trip.passengers[0].firstName + ' ' + trip.passengers[0].lastName | titlecase }}
          </span>
        </div>
      </div>
      <div class="flex flex--middle">
        <fcom-icon [name]="SvgLibraryIcon.ARROW_RIGHT"></fcom-icon>
      </div>
    </div>
  </button>
</ng-template>
